<template>
	<div>
		<v-autocomplete
			class="pr-sm-4 siteDropdown"
			:items="sites"
			:color="ada.blue"
			label="Seiten"
			item-text="Name"
			item-value="Name"
			:loading="loadingSites || loadingSite"
			no-data-text="Keine Seiten verfügbar"
			@change="$emit('change', $event);"
			v-bind:value="value"
			v-on:input="handleInput"
			flat
			chips
			return-object
			:key="key"
			:hide-details="hideDetails"
			auto-select-first
			backgroundColor="#ffffff"
		>
			<template v-slot:selection="{ attr, on, item, selected }">
				<v-chip
					v-bind="attr"
					:input-value="selected"
					:color="ada.darkGrey"
					class="white--text"
					v-on="on"
					label
				>
                    <span v-text="item.Name"
													style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"></span>
				</v-chip>
			</template>
			<template v-slot:item="data">
				<template v-if="typeof data.item !== 'object'">
					<v-list-item-content>{{ data.item }}</v-list-item-content>
				</template>
				<template v-else>
					<v-list-item-icon style="margin-right: 10px;" v-if="displayStatus">
						<v-tooltip top v-if="getColor(data.item.StatusName) !== 'green'">
							<template v-slot:activator="{ on }">
								<v-icon v-on="on" small :color="getColor(data.item.StatusName)">
									mdi-checkbox-blank-circle
								</v-icon>
							</template>
							<span>{{
									getColor(data.item.StatusName) === 'orange' ? 'Seite teilweise deaktiviert' : 'Seite deaktiviert'
								}}</span>
						</v-tooltip>
						<v-icon v-else :color="getColor(data.item.StatusName)" small>
							mdi-checkbox-blank-circle
						</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title><span>{{ data.item.Name }}</span></v-list-item-title>
						<v-list-item-subtitle><span>{{ data.item.group }}</span></v-list-item-subtitle>
					</v-list-item-content>
				</template>
			</template>

			<template v-slot:append-outer="">
				<div style="position: relative;bottom: -7px;">
					<slot></slot>
				</div>
			</template>
		</v-autocomplete>
	</div>
</template>

<script>
import ada from "../../scss/ada_colors.scss";

export default {
	name: "SiteSelect",
	props: {
		value: {},
		onlyStoppedSites: {
			type: [Boolean, Number],
			default: 0,
		},
		hideAdd: {
			type: Boolean,
			default: false
		},
		store: {
			type: String,
			default: 'display'
		},
		beforeChangeEvent: {
			type: Boolean,
			default: false
		},
		ignorePublisherFilter: {
			type: Boolean,
			default: false,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		showStatus: {
			type: Boolean,
			default: false,
		},
		type: {
			type: String,
			default: 'display',
			validator: function (value) {
				// The value must match one of these strings
				return ['display', 'video'].includes(value);
			}
		}
	},
	data: () => {
		return {
			selected: [],
			init: true,
			intervalId: null,
			key: 0,
			ada
		}
	},
	mounted() {
		if (this.publisher && this.$store.state[this.type].sites.length === 0) {
			this.$store.dispatch('display/fetchSites', this.type === 'video');
		}
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		selectedSite() {
			return this.vuexState.selectedSite;
		},
		loadingSites() {
			return this.vuexState.loadingSites;
		},
		loadingSite() {
			return this.vuexState.loadingSite;
		},
		selectedPublisher() {
			return this.$store.state[this.store].selectedPublisher;
		},
		publisher() {
			return this.vuexState.publisher;
		},
		sites() {
			let ret = [];
			let ogSites = this.type === 'video' ? this.$store.state.video.sites : this.vuexState.sites;
			ogSites.forEach((site) => {
				let sitesPublisher = this.vuexState.publisher.find(x => x.PublisherId === site.PublisherId);
				let sitesDeviceTypes = JSON.parse(site.hasTypes);
				if ((this.ignorePublisherFilter || this.selectedPublisher.length === 0 || this.selectedPublisher.includes(sitesPublisher)) && (sitesDeviceTypes.some(r => this.vuexState.device_types.includes(r)) || this.type === 'video')) {
					let tmpSite = JSON.parse(JSON.stringify(site));
					tmpSite.group = sitesPublisher.Name;
					if (this.onlyStoppedSites === 1 || this.onlyStoppedSites) {
						if (tmpSite.StatusName.indexOf('color-green-red') !== -1 || tmpSite.StatusName.indexOf('color-red') !== -1) {
							ret.push(tmpSite);
						}
					} else {
						ret.push(tmpSite);
					}
				}
			});
			return ret;
		},
		readOnly() {
			return this.$store.state.readOnly === 1;
		},
		displayStatus() {
			if (this.showStatus) {
				let role = this.$store.state.users.role;
				let router = this.$router.options.routes.find(x => x.name === this.$route.name);
				return typeof (router.meta) === "undefined" ||
					typeof (router.meta.editRights) === "undefined" ||
					router.meta.editRights.includes(role);
			} else {
				return false;
			}
		}
	},
	methods: {
		getColor(name) {
			if (name.indexOf('color-green-red') !== -1) {
				return 'orange';
			} else if (name.indexOf('color-green') !== -1) {
				return 'green';
			} else if (name.indexOf('color-red') !== -1) {
				return 'red';
			}
		},
		handleInput($event) {
			this.beforeChangeEvent ? this.$emit('beforeChange', $event) : this.$emit('input', $event);
		}
	},
	watch: {
		sites() {
			this.key++;
		},
		publisher() {
			if (this.publisher) {
				this.$store.dispatch('display/fetchSites', this.type === 'video');
			}
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field {
	.v-label {
		top: 14px;

	}

	.v-label--active {
		transform: translateY(-26px) scale(0.75);
	}
}

::v-deep .siteDropdown {
	padding-top: 11px;

	.v-input__slot {

		padding: 5px 0 5px 10px;
		border-top-right-radius: 4px;
	}

	.v-label {
		left: -10px !important;
		top: 6px;
		overflow: initial;
		background: #fff;
		padding: 8px 20px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	.v-input__append-inner .v-input__icon {
		position: relative;
		bottom: -5px;
	}
}
</style>